import React from 'react'
import Slider from 'react-slick';
import './TechnologiesSection.scss'

const TechnologiesSection: React.FC = () => {
    const settings = {
        infinite: true,
        speed: 3000,
        slidesToShow: 4,
        slidesToSxroll: 3,
        centerMode: true,
        autoplay: true,
        autoplaySpeed: 3000,
        pauseOnHover: true
    };
  return (
    <div className='TechnologiesSection'>
        <div className="title">
            Technologies that we use to improve your business
        </div>
        <Slider {...settings}>
            <div className='slide'>
                <div className="client">
1
                </div>
            </div>  
            <div className='slide'>
                <div className="client">
2
                </div>
            </div>
            <div className='slide'>
                <div className="client">
3
                </div>
            </div>
            <div className='slide'>
                <div className="client">
4
                </div>
            </div>
            <div className='slide'>
                <div className="client">
5
                </div>
            </div>
            <div className='slide'>
                <div className="client">
6
                </div>
            </div>
            <div className='slide'>
                <div className="client">
7
                </div>
            </div>
            <div className='slide'>
                <div className="client">
8
                </div>
            </div>
        </Slider>
    </div>
  )
}

export default TechnologiesSection